import React from 'react';

const Logo = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5878 2.00201C17.5878 1.1111 16.5107 0.664933 15.8807 1.2949L1.2949 15.8807C0.664933 16.5107 1.1111 17.5878 2.002 17.5878H17.5878V2.00201Z" fill="black" />
    <path d="M46.1736 17.5878L17.5878 17.5878L17.5879 46.1736C17.5879 47.0645 18.665 47.5106 19.295 46.8807L46.8807 19.2949C47.5107 18.6649 47.0645 17.5878 46.1736 17.5878Z" fill="black" />
  </svg>
);

export default Logo; 